// extracted by mini-css-extract-plugin
module.exports = {"col1":"ParamsTable_col1__3i2Qc","col2":"ParamsTable_col2__9aIjO"};